import createCache from '@emotion/cache'

// See: https://prerender.io/documentation/faq#user-agent
const isPrerender = window.navigator.userAgent.includes('https://github.com/prerender/prerender')

export function createEmotionCache() {
  // When Prerender is the user agent, disable the speedy option to resolve issues with CSS on
  // cached pages. This causes CSS rules to be inserted into the DOM rather than via `insertRule`.
  // See: https://github.com/emotion-js/emotion/tree/master/packages/sheet#speedy
  const options = isPrerender ? { speedy: false } : undefined

  return createCache(options)
}
